


































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import { IFivReport } from 'admiral-core';
import Weekday from 'dayjs/plugin/weekday';
import 'dayjs/locale/de';
import dayjs from 'dayjs';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { CheckSquareIcon, ChevronDownIcon, FileTextIcon, TrashIcon } from 'vue-feather-icons';
import { FivApi } from '@/services/FivApi';

dayjs.extend(Weekday);
dayjs.locale('de');

@Component({
  name: 'report-list-overview',
  components: { FileTextIcon, ChevronDownIcon, TrashIcon, CheckSquareIcon },
})
export default class ReportListOverview extends mixins(BaseMixin) {
  @Prop({ type: Array, required: true })
  reports!: IFivReport[];

  @Prop({ type: Object })
  selectedReport!: IFivReport;

  isContentHovered = false;

  formatDate(date: Date) {
    return dayjs(date).format('DD.MM.YYYY');
  }

  formatIntervalDateItem(date: Date) {
    return dayjs(date).format('MM/YYYY');
  }
  selectReport(report: IFivReport) {
    this.$emit('select-report', report);
  }

  reportQuantity(report: IFivReport) {
    return report.filename ? report.filename.split('$$$').length : 0;
  }

  reportFilename(report: IFivReport) {
    const filenames = report.filename ? report.filename.split('$$$') : [];

    if (filenames.length === 1) {
      return filenames[0];
    }

    if (filenames.length > 1) {
      return filenames[0] + ' + 1 Datei';
    }

    return '';
  }

  async deleteReport(report: IFivReport) {
    try {
      await FivApi.deleteReport(report.id);
      this.$emit('delete-report', report);
      this.$toastr.s('Report erfolgreich gelöscht.');
    } catch (e) {
      this.$toastr.e('Beim Löschen des Reports ist etwas schief gelaufen.');
    }
  }
}
